import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  refreshSyncTargets,
  setSyncTargetsLoadStatus,
  addSyncTargets as addSyncTargetsToUserGroup
} from 'store/redux/userGroups'

export default function * fetchUserGroupSyncTargets (action) {
  const { id, refresh } = action.payload

  const batchedActions = []

  if (refresh) {
    batchedActions.push(refreshSyncTargets({
      id
    }))
  }

  batchedActions.push(setSyncTargetsLoadStatus({
    id,
    loading: true,
    loaded: false
  }))

  yield put(batchedActions)

  try {
    const { Targets } = yield call(apiGetData, 'SyncTargets', {
      groupId: id
    })

    const batchedActions = [
      setSyncTargetsLoadStatus({
        id,
        loading: false,
        loaded: true
      })
    ]

    if (Targets.length) {
      batchedActions.push(addSyncTargetsToUserGroup({
        id,
        syncTargets: Targets.map(SyncTarget => ({
          id: SyncTarget.Id,
          name: SyncTarget.Name,
          permissionLevel: SyncTarget.PermissionLevel
        }))
      }))
    }

    yield put(batchedActions)
  } catch (error) {
    yield put(setSyncTargetsLoadStatus({
      id,
      loading: false,
      loaded: false
    }))

    throw error
  }
}
